import React from 'react';
import i18next from "../../i18n.js";
import { Button } from 'react-bootstrap';

const FormNavigation = (props) => {
    const onNavigate = (index) => {
        if (props.onNavigate) props.onNavigate(index);
    }

    if (props.items?.length > 0) {
        return <div className='form-navigation'>
            <div className='form-navigation-items'>
                {props.items.map((item, index) =>
                    item.visible !== false &&
                    <button type="button" key={index}
                        className={'item' + (props.activeIndex === index ? ' active' : '') + (props.activeIndex > index ? ' visited' : '')}
                        onClick={() => onNavigate(index)}>
                        {item.label}
                    </button>
                )}
            </div>
            {!props.hideBtns && <div className='form-navigation-btns'>
                {props.activeIndex > 0 && <Button className='prev-btn' onClick={() => onNavigate(props.activeIndex - 1)}>{i18next.t('form.navigation.prevBtn')}</Button>}
                {props.activeIndex < props.items.length - 1 && <Button className='next-btn' onClick={() => onNavigate(props.activeIndex + 1)} variant='secondary'>{i18next.t('form.navigation.nextBtn')}</Button>}
            </div>}
        </div>
    }
    return <></>
}
export default FormNavigation;
